import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Global} from "../global";

@Component({
  selector: 'app-pdf-laudo-cd',
  templateUrl: './pdf-laudo-cd.component.html'
})
export class PdfLaudoCDComponent {

  url = '';

  alturaTela;

  constructor(
    public global: Global,
    private route: ActivatedRoute
  ) {
    route.params.subscribe(params => {
      this.url = global.dominio_site+'/adm/laudos-cd/'+params['id_laudo_cd']+'/pdf/?tk='+localStorage.getItem('token');
    });
    this.alturaTela = window.screen.availHeight - 250;
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/pdf-laudo-cd.component.ts